import React from 'react';

import { Box } from '@rbilabs/universal-components';
import { useIntl } from 'react-intl';

import Home from 'pages/home';
import useAuthFlow from 'state/auth/hooks/use-auth-flow';
import { useLoyaltyUserState } from 'state/loyalty/hooks/use-loyalty-user-state';
import { primitive } from 'styles/constants/primitives';

export default function HomeScreen() {
  const { formatMessage } = useIntl();

  const { triggerSignInAccessibility } = useAuthFlow();
  const signInAccessibilityMsg = triggerSignInAccessibility
    ? formatMessage({ id: 'visuallyHiddenSignInSuccess' })
    : '';

  useLoyaltyUserState({ refreshOnMountOrFocus: true });

  return (
    <Box
      backgroundColor={primitive.bk.$mayoEggWhite}
      flex={1}
      testID="homepage"
      accessibilityLabel={signInAccessibilityMsg}
      accessibilityRole="alert"
    >
      <Home />
    </Box>
  );
}
